import * as requests from '../api-request'

export const createProject = async (data = {}) => {
  return requests.toJSON('POST', 'project', data)
}

export const getProjects = async () => {
  return requests.toJSON('GET', 'project')
}

export const getSingleProject = async (projectUuid) => {
  return requests.toJSON('GET', `project/${projectUuid}`)
}

export const getProjectScripts = async (projectUuid) => {
  return requests.toJSON('GET', `project/scripts/${projectUuid}`)
}

// One summary per draft for a project tab's cards; at most 12 script uuids per call.
export const getFeatureCards = async ({ projectUuid, feature, scripts = [] }, signal) => {
  const query = scripts.map(encodeURIComponent).join(',')
  return requests.toJSON('GET', `project/cards/${projectUuid}/${feature}?scripts=${query}`, {}, undefined, signal)
}

export const copyScript = async ({ projectUuid, scriptUuid }) => {
  return requests.toJSON('POST', `project/scripts/${projectUuid}/${scriptUuid}/copy`)
}

export const drawCover = async (data) => {
  return requests.toJSON('POST', 'project/draw_cover', data)
}

export const updateProjectInfo = async (data, uuid) => {
  return requests.toJSON('PATCH', `project/${uuid}`, data)
}

export const deleteProject = async (projectUuid) => {
  return requests.toJSON('DELETE', `project/${projectUuid}`)
}

export const assignScriptToProject = async (data) => {
  return requests.toJSON('POST', 'project/assign_script_to_project', data)
}

export const checkScriptBelongsToProject = async (data) => {
  return requests.toJSON('POST', 'project/script_belongs_to_project', data)
}

export const checkCanEdit = async (projectUuid) => {
  return requests.toJSON('GET', `project/${projectUuid}/can_edit`)
}
